<template>
    <div class="filter-panel-popup">
        <Popup ref="popup" :minWidth="320" :minHeight="300" :is-show="isShowPopup" :isShowClose="true"
            @closed="onClosedPopup" title="Bộ lọc dữ liệu" :height="$app.isMobile ? '100%' : '570px'"
            :width="$app.isMobile ? '100%' : '460px'" :isShowOverlay="true">
            <template slot="body">
                <div class="px-2">
                    <div class="mb-4">
                        <div class="title">
                            <i class="el-icon-date"></i>
                            Kỳ dữ liệu
                        </div>
                        <div class="w-full">
                            <el-date-picker v-model="selectedDateRange" class="custom-picker" type="daterange"
                                format="dd/MM/yyyy" range-separator="đến" start-placeholder="Ngày bắt đầu"
                                end-placeholder="Ngày kết thúc" popper-class="custom-prop" @change="handleDateChange">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="title">
                            <i class="el-icon-date"></i>
                            Kỳ dữ liệu thường dùng
                        </div>
                        <div class="flex gap-3 flex-auto items-center my-1">
                            <div class="md:text-sm text-xs flex items-center" v-for="(date, index) in dateOptions"
                                :key="index">
                                <input type="radio" :id="index" v-model="selectedRange" :value="date.key"
                                    @change="pickDate(date)" />
                                <label :for="index" class="ml-1">{{ date.label }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="title">
                            <i class="el-icon-search"></i>
                            Tìm mã phiếu
                        </div>
                        <el-input placeholder="VD: PC12345" :clearable="true" v-model="searchCode"></el-input>
                    </div>
                    <div class="mb-4">
                        <div for="billType" class="title">
                            <i class="el-icon-tickets"></i>
                            Loại phiếu
                        </div>
                        <el-select id="billType" class="h-[36px] w-full" placeholder="Chọn loại phiếu"
                            v-model="selectedBillType" :clearable="true">
                            <el-option v-for="type in $app.billTypes" :key="type.value" :label="type.label"
                                :value="type.value">
                                {{ type.label }}
                            </el-option>
                        </el-select>
                    </div>
                    <div class="mb-4">
                        <div class="title">
                            <i class="el-icon-document-copy"></i>
                            Nhóm phiếu
                        </div>
                        <div>
                            <el-select id="billType" class="h-[36px] w-full" placeholder="Chọn nhóm phiếu"
                                v-model="formBills" :clearable="true">
                                <el-option v-for="type in listBillOption" :key="type.value" :label="type.text"
                                    :value="type.value">
                                    {{ type.text }}
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="title">
                            <i class="el-icon-office-building"></i>
                            Bộ phận
                        </div>
                        <div>
                            <el-select class="w-full h-[36px]" v-model="departmentAdmin" placeholder="Chọn bộ phận"
                                :clearable="true">
                                <el-option v-for="item in $app.userInfo.departments" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="mb-3" v-if="formBills == 1 || formBills == 3">
                        <div class="title">
                            <i class="el-icon-school"></i>
                            Cửa hàng
                        </div>
                        <div class="mb-1">
                            <el-autocomplete class="w-full h-[36px]" v-model="fillBillAddress"
                                placeholder="Tìm cửa hàng" :fetch-suggestions="searchStore" clearable
                                @clear="handleClear" @select="handleSelect" popper-class="search-stores-prop">
                                <template slot-scope="{ item }">
                                    <div class="text-sm">
                                        {{ item.shortaddress }}
                                    </div>
                                </template>
                            </el-autocomplete>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="title">
                            <i class="el-icon-document-checked"></i>
                            Trạng thái phiếu
                        </div>
                        <div>
                            <el-checkbox-group v-model="selectedValues" @change="onChange" class="flex flex-col gap-2">
                                <el-checkbox :label="0">Phiếu đã huỷ</el-checkbox>
                                <el-checkbox label="1_false">Phiếu chờ ký</el-checkbox>
                                <el-checkbox label="1_true">Phiếu KTT/TP đã ký</el-checkbox>
                                <el-checkbox label="2_false">Phiếu chưa ký đủ</el-checkbox>
                                <el-checkbox label="2_true">Phiếu đã ký đủ</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    
                    <div class="mb-4" v-if="isHDHLMode">
                        <div class="title">
                            <i class="el-icon-office-building"></i>
                            Công ty
                        </div>
                        <el-select
                            v-model="company"
                            placeholder="Chọn công ty"
                            clearable
                            filterable
                            class="w-full h-[36px]"
                        >
                            <el-option
                                v-for="(item, idx) in listCompanies"
                                :key="idx"
                                :label="item.name"
                                :value="item.name"
                            ></el-option>
                        </el-select>
                    </div>

                    <div class="mb-4" v-if="isHDHLMode">
                        <div class="title">
                            <i class="el-icon-date"></i>
                            Ngày chi thực tế
                        </div>
                        <div class="w-full">
                            <el-date-picker v-model="actualPaymentDateRange" class="custom-picker" type="daterange"
                                format="dd/MM/yyyy" range-separator="đến" start-placeholder="Từ ngày"
                                end-placeholder="Đến ngày" popper-class="custom-prop" @change="handleActualPaymentDateChange">
                            </el-date-picker>
                        </div>
                    </div>
                    
                    <!-- Lọc Trạng thái Hợp Lệ (Chỉ hiển thị khi isHDHLMode là true) -->
                    <div class="mb-4" v-if="isHDHLMode">
                        <div class="title">
                            <i class="el-icon-circle-check"></i>
                            Trạng thái Hợp lệ
                        </div>
                        <el-select class="w-full h-[36px]" v-model="selectedValidStatus" placeholder="Chọn trạng thái" :clearable="true">
                            <el-option label="Đã hợp lệ" :value="true"></el-option>
                            <el-option label="Chưa xử lý" :value="false"></el-option>
                        </el-select>
                    </div>

                </div>
            </template>
            <template slot="footer">
                <div class="w-full z-20 flex gap-3 p-2">
                    <button
                        class="flex-1 px-4 py-2.5 text-white font-bold rounded-lg bg-brand hover:bg-brand-light shadow-[0_4px_10px_rgba(2,75,179,0.3)] hover:-translate-y-[1px] transition-all duration-200 text-[14px]"
                        @click="submitFilter">Lọc dữ liệu
                    </button>
                    <button
                        class="w-[120px] px-4 py-2.5 font-bold rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 hover:text-gray-800 transition-colors text-[14px]"
                        @click="resetFilter">Reset bộ lọc
                    </button>
                </div>
            </template>
        </Popup>
    </div>
</template>
<script>
import Popup from "../component/common/Popup.vue";
import dayjs from "dayjs";

const API_URL = process.env.VUE_APP_API_URL
export default {
    components: {
        Popup
    },
    computed: {
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        useGlobalState: {
            type: Boolean,
            default: true,
        },
        isHDHLMode: {
            type: Boolean,
            default: false,
        },
        initialFilters: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            isShowPopup: false,
            selectedDateRange: null,
            selectedRange: null,
            selectedValidStatus: null,
            selectedBillType: null,
            listAddress: [],
            dateOptions: [
                {
                    key: 'thisWeek',
                    label: 'Tuần này',
                    value: {
                        start: dayjs().startOf("week").format("YYYY-MM-DD HH:mm:ss"),
                        end: dayjs().endOf("week").format("YYYY-MM-DD HH:mm:ss"),
                    },
                },
                {
                    key: 'thisMonth',
                    label: 'Tháng này',
                    value: {
                        start: dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
                        end: dayjs().endOf("month").format("YYYY-MM-DD HH:mm:ss"),
                    },
                },
                {
                    key: 'lastMonth',
                    label: 'Tháng trước',
                    value: {
                        start: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD HH:mm:ss"),
                        end: dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD HH:mm:ss"),
                    },
                },
                {
                    key: 'older',
                    label: 'Cũ hơn',
                    value: {
                        start: dayjs().subtract(1, "year").startOf("month").format("YYYY-MM-DD HH:mm:ss"),
                        end: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD HH:mm:ss"),
                    },
                },
            ],
            departmentAdmin: null,
            options: [],
            fillBillAddress: null,
            fillBillAddressValue: null,
            formBills: null,
            listAddressDefault: [],
            searchTimeout: null,
            searchCode: null,
            selectedValues: [],
            checkStatus: [],
            company: null,
            actualPaymentDateRange: null,
            listCompanies: []

        }
    },
    async mounted() {
        if (this.isShow) {
            this.isShowPopup = true
            this.setCurrentFilterData()
            this.$nextTick(() => {
                this.checkCurrentRange()
            })
            document.body.style.overflow = 'hidden'
        }
        if (this.$app.userInfo.stores.length > 0) {
            this.listAddressDefault = this.$app.userInfo.stores;
        } else {
            await this.fetchStores()
        }
        await this.fetchCompanies();

    },
    beforeDestroy() {
        document.body.style.overflow = ''
    },
    computed: {
        listBillOption() {
            const base = this.$app.billOptions || [];
            return [{ value: 0, text: 'Tất cả' }, ...base];
        }
    },
    methods: {
        resetFilter() {
            if (this.useGlobalState) {
                this.$app.selectedDateRange = [dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"), dayjs().endOf("month").format("YYYY-MM-DD HH:mm:ss")];
                this.$app.departmentAdmin = null;
                this.$app.fillBillAddressValue = null;
                this.$app.formBills = null;
                this.$app.selectedBillType = null;
                this.$app.searchCode = '';
                this.$app.checkStatus = [];
                this.$app.company = null;
                this.$app.actualPaymentDateRange = null;
                if (this.isHDHLMode) this.$app.selectedValidStatus = null;
                this.onClosedPopup(true);
            } else {
                const resetData = {
                    selectedDateRange: [dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"), dayjs().endOf("month").format("YYYY-MM-DD HH:mm:ss")],
                    departmentAdmin: null,
                    fillBillAddressValue: null,
                    formBills: null,
                    selectedBillType: null,
                    searchCode: null,
                    checkStatus: [],
                    company: null,
                    actualPaymentDateRange: null,
                    selectedValidStatus: null
                };
                this.onClosedPopup(resetData);
            }
        },
        onChange(values) {
            this.checkStatus = values.map(v => {
                if (typeof v === 'number') {
                    // trường hợp label là số (0)
                    return { value: v, isSign: false };
                }
                if (typeof v === 'string' && v.includes('_')) {
                    const [valueStr, signStr] = v.split('_');
                    return {
                        value: parseInt(valueStr),
                        isSign: signStr === 'true'
                    };
                }
            });
        },
        setCurrentFilterData() {
            if (this.useGlobalState) {
                this.selectedDateRange = this.$app.selectedDateRange
                this.departmentAdmin = this.$app.departmentAdmin
                this.fillBillAddressValue = this.$app.fillBillAddressValue
                this.fillBillAddress = this.$app.fillBillAddressValue?.shortaddress
                this.formBills = this.$app.formBills
                this.selectedBillType = this.$app.selectedBillType
                this.searchCode = this.$app.searchCode
                this.checkStatus = this.$app.checkStatus
                this.company = this.$app.company || null
                this.actualPaymentDateRange = this.$app.actualPaymentDateRange || null
                if (this.isHDHLMode) this.selectedValidStatus = this.$app.selectedValidStatus || null
            } else {
                this.selectedDateRange = this.initialFilters.selectedDateRange || null
                this.departmentAdmin = this.initialFilters.departmentAdmin || null
                this.fillBillAddressValue = this.initialFilters.fillBillAddressValue || null
                this.fillBillAddress = this.initialFilters.fillBillAddressValue?.shortaddress || null
                this.formBills = this.initialFilters.formBills || null
                this.selectedBillType = this.initialFilters.selectedBillType || null
                this.searchCode = this.initialFilters.searchCode || null
                this.checkStatus = this.initialFilters.checkStatus || []
                this.company = this.initialFilters.company || null
                this.actualPaymentDateRange = this.initialFilters.actualPaymentDateRange || null
                this.selectedValidStatus = this.initialFilters.selectedValidStatus !== undefined ? this.initialFilters.selectedValidStatus : null
            }
            if (this.checkStatus && this.checkStatus.length > 0) {
                this.reverseChange()
            }
        },
        reverseChange() {
            this.selectedValues = this.checkStatus.map(item => {
                if (item.value === 0) {
                    return 0;
                }
                return `${item.value}_${item.isSign}`;
            });
        },
        async fetchStores() {
            try {
                const response = await this.$axios.get(`${API_URL}/stores/getall`);
                this.listAddressDefault = response.data
            } catch (error) {
                console.error("Lỗi khi lấy danh sách cửa hàng:", error);
            }
        },
        async fetchCompanies() {
            try {
                const response = await this.$axios.get(`${API_URL}/companies-list/all`);
                this.listCompanies = response.data.data;
            } catch (error) {
                console.error("Lỗi khi lấy danh sách công ty:", error);
            }
        },
        searchStore(queryString, cb) {
            if (!queryString) {
                return cb(
                    this.listAddressDefault
                );
            }

            clearTimeout(this.searchTimeout);

            this.searchTimeout = setTimeout(() => {
                const searchLower = queryString.toLowerCase();

                const filtered = this.listAddressDefault.filter((item) => {
                    const short = item.shortaddress ? item.shortaddress.toLowerCase() : "";
                    const full = item.fulladdress ? item.fulladdress.toLowerCase() : "";
                    return short.includes(searchLower) || full.includes(searchLower);
                });
                this.listAddress = filtered
                cb(this.listAddress);
            }, 300);
        },
        handleSelect(item) {
            this.fillBillAddress = item.shortaddress
            this.fillBillAddressValue = item
        },
        handleClear() {
            this.fillBillAddress = null
            this.fillBillAddressValue = null
        },
        onClosedPopup(returnData = null) {
            this.isShowPopup = false
            this.$nextTick(() => {
                this.$emit('closed', returnData)
            })
        },
        submitFilter() {
            const newFilters = {
                selectedDateRange: this.selectedDateRange,
                departmentAdmin: this.departmentAdmin,
                fillBillAddressValue: this.fillBillAddressValue,
                formBills: this.formBills,
                selectedBillType: this.selectedBillType,
                searchCode: this.searchCode,
                checkStatus: this.checkStatus,
                company: this.company,
                actualPaymentDateRange: this.actualPaymentDateRange,
                selectedValidStatus: this.selectedValidStatus
            };
            if (this.useGlobalState) {
                this.$app.selectedDateRange = this.selectedDateRange
                this.$app.departmentAdmin = this.departmentAdmin
                this.$app.fillBillAddressValue = this.fillBillAddressValue
                this.$app.formBills = this.formBills
                this.$app.selectedBillType = this.selectedBillType
                this.$app.searchCode = this.searchCode
                this.$app.checkStatus = this.checkStatus
                this.$app.company = this.company
                this.$app.actualPaymentDateRange = this.actualPaymentDateRange
                if (this.isHDHLMode) this.$app.selectedValidStatus = this.selectedValidStatus
            }
            this.onClosedPopup(newFilters)
        },
        handleDateChange(value) {
            if (!value || value.length !== 2) {
                this.selectedDateRange = null;
                return;
            }
            let currChange = value.map(date => this.formatDate(date));
            this.selectedDateRange = [dayjs(currChange[0]).startOf("day").format("YYYY-MM-DD HH:mm:ss"), dayjs(currChange[1]).endOf("day").format("YYYY-MM-DD HH:mm:ss")]
            this.checkCurrentRange()
        },
        handleActualPaymentDateChange(value) {
            if (!value || value.length !== 2) {
                this.actualPaymentDateRange = null;
                return;
            }
            let currChange = value.map(date => this.formatDate(date));
            this.actualPaymentDateRange = [dayjs(currChange[0]).startOf("day").format("YYYY-MM-DD HH:mm:ss"), dayjs(currChange[1]).endOf("day").format("YYYY-MM-DD HH:mm:ss")]
        },
        checkCurrentRange() {
            let find = this.dateOptions.find(el => dayjs(el.value.start).isSame(this.selectedDateRange[0], 'day') && dayjs(el.value.end).isSame(this.selectedDateRange[1], 'day'))
            if (find) {
                this.selectedRange = find.key
            } else {
                this.selectedRange = null
            }
        },
        formatDate(date) {
            return dayjs(date).format("YYYY-MM-DD")
        },
        pickDate(e) {
            this.selectedDateRange = [e.value.start, e.value.end]
        },

    }
}
</script>
<style lang="scss" scoped>
.filter-panel-popup {
    .title {
        @apply text-[14px] font-semibold mb-1
    }
}
</style>